import { Component, Input, Output, EventEmitter,
         ViewChild }                              from '@angular/core';
import { Response }                               from '@angular/http';
import { Observable }                             from 'rxjs/Observable';

import { ExistingUser }                           from '../../../models/program/existing-user';
import { NewAndExistingUsers }                    from '../../../models/program/new-and-existing-users';

import { AdminService }                           from '../admin.service';
import { ErrorService }                           from '../../../shared/services/error.service';

@Component({
  selector: 'app-add-global-admins',
  templateUrl: './add-global-admins.component.html',
  styleUrls: ['./add-global-admins.component.less']
})

export class AddGlobalAdminsComponent {
  @Output() saved: EventEmitter<number[]> = new EventEmitter<number[]>();
  public newAndExisting: NewAndExistingUsers;

  public errors: string[];
  public saving = false;

  constructor(
    private errorService: ErrorService,
    private adminService: AdminService
  ) { }

  public addAdmins(): void {
    const requests = this.adminService.makeAdmins(this.newAndExisting).subscribe(res => {
      this.saving = false;
      this.errors = [];
      this.adminService.getAdmins(); // trigger a reload to update the table
      this.saved.emit();
    }, err => {
      this.saving = false;
      // TODO: show error to user
      console.log('unable to move users into this group');
      console.log(err);
      this.errors = this.errorService.messages(err);
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-settings/administrators/add-global-admins/add-global-admins.component.ts